import React from 'react';
import { STORAGE_KEYS } from '../../utils/storage';
import { OnboardingSurvey } from '../../components/Onboarding/OnboardingSurvey';

export const OnboardingSurveyPage: React.FC = () => {
  const handleSurveyStart = () => {
    localStorage.removeItem(STORAGE_KEYS.ONBOARDING_DATA);
  };

  const handleError = () => {
    localStorage.removeItem(STORAGE_KEYS.ONBOARDING_DATA);
  };

  return <OnboardingSurvey onSurveyStart={handleSurveyStart} onError={handleError} />;
};
